import tickIcon from "assets/images/icons/tick.png";
// import { Fade } from "react-awesome-reveal";

const Features2 = () => {
  // data
  let featuresData = [
    {
      desc: `Reduce Anget & Increase Patience`,
    },
    {
      desc: `Overcome Anxiety & Overwhelm`,
    },
    {
      desc: `7 Minute De-Stress SOS`,
    },
    {
      desc: `Feel Happier Now`,
    },
    {
      desc: `Deal with my Misbehaving Child with Love`,
    },
    {
      desc: `Deep & Restful Sleep`,
    },
  ];
  return (
    <div className="features_wrapper">
      {/* <Fade
       
        direction="up"
        triggerOnce
        delay={750 + (index + 100)}
        duration={1400}
      > */}
      {featuresData?.map((item, index) => (
          <div key={index} className="feature_box feature_box2 d_flex">
            <div className="feature_icon">
              <img src={tickIcon} alt="" />
            </div>
            <div className="feature_content">
              <p>{item?.desc}</p>
            </div>
          </div>
      ))}
      {/* </Fade> */}
    </div>
  );
};

export default Features2;
